const ADDRESS_TYPES = {
    street_number: 'street_number',
    route: 'route',
    postal_code: 'postal_code',
    administrative_area_level_1: 'province',
    locality: 'location',
  }

const parseAddressComponents = (address_components) => {
  let formattedAddress = {}
  Object.entries(ADDRESS_TYPES).forEach(([key, value]) => {
    formattedAddress[value] =
      address_components.find((component) => component.types.includes(key))
        ?.long_name ?? ''
  })

  const { street_number, route, postal_code, province, location } =
    formattedAddress

  const address = `${route} ${street_number}, ${postal_code}`

  return {
    address,
    province,
    location,
  }
}

export const reverseGeocode = async (t, lat, lng) => {
  if (!window.google) {
    throw new Error(t('geocode.api.status.fail'))
  }
  const geocoder = new window.google.maps.Geocoder()
  return new Promise((resolve, reject) => {
    geocoder.geocode(
      {
        location: { lat: parseFloat(lat), lng: parseFloat(lng) },
        language: localStorage.getItem("lang"),
      },
      (results, status) => {
        if (status === 'OK' && results) {         
          const addressComponents = results.find((result) => result.types.includes("street_address")).address_components
          const addressDetails = parseAddressComponents(addressComponents)
          resolve(addressDetails)
        } else {
          reject(new Error(t("geocode.api.status.wrong")))
        }
      }
    )
  })
}
